// removed by extract-text-webpack-plugin
module.exports = {"snackbar":"src-components-common-Snackbar-styles__snackbar--18DvL","fadein":"src-components-common-Snackbar-styles__fadein--tGsMW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Snackbar/styles.scss
// module id = 181
// module chunks = 0